<div [class.is-filtered]="isFiltered">
  <mat-form-field>
    <mat-label>Filter</mat-label>
    <mat-select [formControl]="element" [multiple]="multiple" [compareWith]="compareWith">
      <mat-option>
        <ngx-mat-select-search
          [clearSearchInput]="false"
          [formControl]="filterCtrl"
          noEntriesFoundLabel="Geen data"
          placeholderLabel="Zoeken ..."
        ></ngx-mat-select-search>
      </mat-option>
      <ng-container *ngFor="let option of optionElements | async">
        <ng-container *ngIf="hasOptions(option)">
          <mat-optgroup [label]="option.display_name ?? option.name">
            <mat-option *ngFor="let option1 of option.options" [value]="{id: option1.id, type: option.type}">
              {{ option1.display_name ?? option1.name }}
            </mat-option>
          </mat-optgroup>
        </ng-container>
        <ng-container *ngIf="!hasOptions(option)">
          <mat-option [value]="{id: option.id}" [class.is-disabled]="option.is_deleted || option.is_active === false" [class.is-hidden]="option.is_visible === false">{{ option.display_name ?? option.name }}</mat-option>
        </ng-container>
      </ng-container>
    </mat-select>
  </mat-form-field>
  <button (click)="clearFilterButton()" [class.show]="isFiltered" mat-icon-button type="button">
    <mat-icon>clear</mat-icon>
  </button>
</div>
